import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const MainBlock = styled.div<{ width: number; isActive: boolean; isDisabled?: boolean; $compact?: boolean }>`
  border: 1px solid ${({ isActive }) => (isActive ? theme.colors.AccentNaplesYellow : theme.colors.DarkBlue100)};
  background: ${theme.colors.SurfaceWhite};
  /* Desktop defaults (non-compact). Compact visuals applied only on mobile */
  box-shadow: 4px 4px 4px 0 #a7a7a740;
  position: relative;

  display: flex;
  flex-direction: row;
  width: ${({ width }) => (width ? `${width}%` : 'auto')};
  padding: 20px 24px;

  border-radius: 8px;
  gap: 30px;

  &:hover {
    cursor: ${({ isDisabled }) => (isDisabled ? 'not-allowed' : 'pointer')};
    background-color: #fffbeb;
  }

  transition: background-color 0.2s ease;

  align-items: center;

  ${({ isDisabled }) =>
    isDisabled &&
    `
  &:before {
    content: "";
    position: absolute;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    left: 0;
  }
  `};

  @media (max-width: 768px) {
    width: 100% !important;
    flex-wrap: wrap;
    /* Compact visuals are scoped to mobile */
    padding: ${({ $compact }) => ($compact ? '12px 16px' : '20px 24px')};
    row-gap: ${({ $compact }) => ($compact ? '8px' : '12px')};
    column-gap: 8px;
    box-shadow: ${({ $compact }) => ($compact ? '2px 2px 4px 0 #a7a7a726' : '4px 4px 4px 0 #a7a7a740')};
    gap: ${({ $compact }) => ($compact ? '12px' : '30px')};
  }
`;
